/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle[_ngcontent-%COMP%]{width:25%;border-radius:50%;text-align:center;font-size:40px;line-height:0;position:relative;background:#e21b6c;color:#fff}.box-shadow[_ngcontent-%COMP%]{box-shadow:0 .25rem .75rem rgba(0,0,0,.05)}.text-body[_ngcontent-%COMP%]{height:80px;padding:10px}#styleBotao[_ngcontent-%COMP%]:focus{background-color:#fff}#styleBotao[_ngcontent-%COMP%]:active{background-color:#e21b6c}\n/*# sourceMappingURL=faq.component.css.map*/"];
export { styles as styles };
